import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("kf_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const peso = (n) =>
  `₱${Number(n || 0).toLocaleString("en-PH", { maximumFractionDigits: 0 })}`;

export const formatPHPhone = (raw) => {
  const digits = String(raw || "").replace(/\D/g, "");
  if (!digits) return "";
  let n = digits;
  if (n.startsWith("63")) n = n.slice(2);
  if (n.startsWith("0")) n = n.slice(1);
  // n should now be like 9171234567
  if (n.length <= 3) return `+63 ${n}`;
  if (n.length <= 6) return `+63 ${n.slice(0, 3)} ${n.slice(3)}`;
  return `+63 ${n.slice(0, 3)} ${n.slice(3, 6)} ${n.slice(6, 10)}`;
};
